import React from 'react';
import i18n from 'i18next';
import { formatCurrency } from '../utils/formatCurrency';
import { getDateLocale } from '../utils/dateLocale';
import './TicketTemplate.css';

class TicketTemplate extends React.Component {
  render() {
    const { order, restaurant, type = 'customer' } = this.props;
    const printSettings = restaurant?.printSettings || {};
    const kitchenFontSize = printSettings.kitchenFontSize || 'medium';

    if (!order) return null;

    const formatDate = (dateString) => {
      return new Date(dateString).toLocaleString(getDateLocale(i18n.language), {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });
    };

    return (
      <div className={`ticket-container ${type === 'kitchen' ? `kitchen-${kitchenFontSize}` : ''}`}>
        <div className="ticket-header">
          {printSettings.showLogo !== false && restaurant?.logo && (
            <img src={restaurant.logo} alt="Logo" className="ticket-logo" />
          )}

          {type === 'customer' && printSettings.headerText && (
            <p className="ticket-custom-header">{printSettings.headerText}</p>
          )}

          <h2>{restaurant?.name || 'Restaurante'}</h2>
          <p>{restaurant?.address}</p>
          <p>Tel: {restaurant?.phone}</p>
        </div>

        <div className="ticket-meta">
          <p>
            <strong>Pedido #{order.orderId.slice(-6)}</strong>
          </p>
          <p>{formatDate(order.createdAt)}</p>
          {order.orderType === 'takeaway' ? (
            <p>
              <strong>PARA LLEVAR</strong>
            </p>
          ) : (
            <p>
              <strong>MESA: {order.tableNumber}</strong>
            </p>
          )}
          {order.customerInfo && (
            <div className="customer-info">
              <p>Cliente: {order.customerInfo.name}</p>
              <p>Tel: {order.customerInfo.phone}</p>
            </div>
          )}
        </div>

        <div className="ticket-divider">--------------------------------</div>

        <div className="ticket-items">
          {order.items.map((item, index) => (
            <div key={index} className="ticket-item">
              <div className="item-row">
                <span className="item-qty">{item.quantity}x</span>
                <span className="item-name">{item.name}</span>
                {type === 'customer' && (
                  <span className="item-price">{formatCurrency(item.price * item.quantity)}</span>
                )}
              </div>
              {/* Modificadores seleccionados */}
              {item.selectedModifiers && item.selectedModifiers.length > 0 && (
                <div className="item-modifiers">
                  {item.selectedModifiers.map((mod, modIndex) => (
                    <div key={modIndex} className="modifier-row">
                      <span className="modifier-bullet">→</span>
                      <span className="modifier-name">{mod.name}</span>
                      {type === 'customer' && mod.price > 0 && (
                        <span className="modifier-price">+{formatCurrency(mod.price)}</span>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {item.notes && <div className="item-notes">(Nota: {item.notes})</div>}
            </div>
          ))}
        </div>

        <div className="ticket-divider">--------------------------------</div>

        {type === 'customer' && (
          <div className="ticket-totals">
            {order.subtotal && (
              <>
                <div className="total-row">
                  <span>Subtotal:</span>
                  <span>{formatCurrency(order.subtotal)}</span>
                </div>
                <div className="total-row">
                  <span>Servicio (10%):</span>
                  <span>{formatCurrency(order.serviceCharge)}</span>
                </div>
                <div className="total-row">
                  <span>IVA (21%):</span>
                  <span>{formatCurrency(order.tax)}</span>
                </div>
              </>
            )}
            {order.discount && (
              <div className="total-row">
                <span>
                  Descuento{' '}
                  {order.discount.type === 'percentage' ? `(${order.discount.value}%)` : ''}:
                </span>
                <span>-{formatCurrency(order.discount.amount)}</span>
              </div>
            )}
            <div className="total-row final">
              <strong>TOTAL:</strong>
              <strong>{formatCurrency(order.total)}</strong>
            </div>
          </div>
        )}

        <div className="ticket-footer">
          {type === 'customer' && printSettings.footerText && (
            <p className="ticket-custom-footer">{printSettings.footerText}</p>
          )}
          <p>*** {type === 'kitchen' ? 'FIN COMANDA' : 'GRACIAS POR SU COMPRA'} ***</p>
          <p>Resto</p>
        </div>
      </div>
    );
  }
}

export default TicketTemplate;
